import { CommandController } from './../../../commanding/CommandController';
import { SimpleCommand } from './../../../commanding/SimpleCommand';


import { BasicController } from "../BasicController";

export class BasicConnectionFailedCommand extends SimpleCommand {
    public execute(commandVars: any = null): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_PREPARE_RECONNECT);
    }
}

